module.exports = __webpack_public_path__ + "static/vegas13-3-07ea709d58be860c23adbabb2ae8ab4d.jpg";